/**
 * Safe sessionStorage utilities with error handling
 */

/**
 * Safely get a value from sessionStorage
 * @param {string} key - Storage key
 * @returns {string|null} Stored value or null if error/not found
 */
export function safeGetSessionStorage(key) {
  try {
    return sessionStorage.getItem(key);
  } catch (error) {
    // Ignore sessionStorage errors (e.g., in private browsing mode)
    return null;
  }
}

/**
 * Safely set a value in sessionStorage
 * @param {string} key - Storage key
 * @param {string} value - Value to store
 * @returns {boolean} True if successful, false otherwise
 */
export function safeSetSessionStorage(key, value) {
  try {
    sessionStorage.setItem(key, value);
    return true;
  } catch (error) {
    // Ignore sessionStorage errors (e.g., in private browsing mode)
    return false;
  }
}

/**
 * Safely remove a value from sessionStorage
 * @param {string} key - Storage key
 * @returns {boolean} True if successful, false otherwise
 */
export function safeRemoveSessionStorage(key) {
  try {
    sessionStorage.removeItem(key);
    return true;
  } catch (error) {
    // Ignore sessionStorage errors
    return false;
  }
}

/**
 * Check if a service selection exists in sessionStorage
 * @returns {boolean} True if selectedServiceSlug exists in sessionStorage
 */
export function hasSessionSelection() {
  try {
    return Boolean(sessionStorage.getItem('selectedServiceSlug'));
  } catch (_) {
    return false;
  }
}

